module.exports = __webpack_public_path__ + "img/yusuf-belek-gHdVUGAJYGo-unsplash.466bc559.jpg";